<template>
    <div>
        <el-table
                :data="this.$store.getters.currentCardList"
                style="width: 100%"
                height="250">

            <el-table-column
                    fixed
                    prop="id"
                    label="ID"
                    width="80">
            </el-table-column>
            <el-table-column
                    prop="word"
                    label="单词"
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="cixing"
                    label="词性"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="fanyi"
                    label="翻译"
                    width="420">
            </el-table-column>
            <el-table-column
                    prop="yinjie"
                    label="音节"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="yinbiao"
                    label="音标"
                    width="150">
            </el-table-column>

        </el-table>
    </div>
</template>

<script>
    export default {
        name: "WordTableListP",
        data() {
            return {
                tableData: [{
                    date: '2016-05-03',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                }, {
                    date: '2016-05-02',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                }, {
                    date: '2016-05-04',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                }, {
                    date: '2016-05-01',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                }, {
                    date: '2016-05-08',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                }, {
                    date: '2016-05-06',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                }, {
                    date: '2016-05-07',
                    name: '王小虎',
                    province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区金沙江路 1518 弄',
                    zip: 200333
                }]
            }
        }
    }
</script>

<style scoped>

</style>